import styled from "styled-components";

export const FormSubmit = styled.div`
    display: flex;
    justify-content: space-between;

    padding-top: 4px;
    margin-top: 12px;

    box-shadow: var(--color-title-underline) 0 -1px 0;
`;